import * as api from '../resources/sftp.api';
import actionTypes from './action-types';

export const fetchSftpListRequest = () => ({
  type: actionTypes.FETCH_SFTP_LIST_REQUEST,
  name: 'sftpListLoadingStatus',
});

export const fetchSftpListSuccess = (sftpList, pagination) => ({
  type: actionTypes.FETCH_SFTP_LIST_SUCCESS,
  name: 'sftpListLoadingStatus',
  sftpList,
  pagination,
});

export const fetchSftpListFailure = () => ({
  type: actionTypes.FETCH_SFTP_LIST_FAILURE,
  name: 'sftpListLoadingStatus',
});

export const fetchSftpList = (requestParams) => async (dispatch) => {
  try {
    dispatch(fetchSftpListRequest());

    const { content, ...pagination } = await api.fetchSftpList(requestParams);
    dispatch(fetchSftpListSuccess(content, pagination));
  } catch (error) {
    console.error('FETCH_SFTP_LIST', error);
    dispatch(fetchSftpListFailure());
  }
};

export const deleteSftpByIdRequest = () => ({
  type: actionTypes.DELETE_SFTP_BY_ID_REQUEST,
});

export const deleteSftpByIdSuccess = () => ({
  type: actionTypes.DELETE_SFTP_BY_ID_SUCCESS,
});

export const deleteSftpByIdFailure = () => ({
  type: actionTypes.DELETE_SFTP_BY_ID_FAILURE,
});

export const deleteSftpById = (id) => async (dispatch) => {
  try {
    dispatch(deleteSftpByIdRequest());

    await api.deleteSftpById(id);

    dispatch(deleteSftpByIdSuccess());
  } catch (error) {
    console.error('DELETE_SFTP_BY_ID', error);
    dispatch(deleteSftpByIdFailure());
  }
};

export const fetchSftpByIdRequest = () => ({
  type: actionTypes.FETCH_SFTP_BY_ID_REQUEST,
});

export const fetchSftpByIdSuccess = (sftp) => ({
  type: actionTypes.FETCH_SFTP_BY_ID_SUCCESS,
  sftp,
});

export const fetchSftpByIdFailure = () => ({
  type: actionTypes.FETCH_SFTP_BY_ID_FAILURE,
});

export const fetchSftpById = (id) => async (dispatch) => {
  try {
    dispatch(fetchSftpByIdRequest());

    const sftp = await api.fetchSftpById(id);

    dispatch(fetchSftpByIdSuccess(sftp));
  } catch (error) {
    console.error('FETCH_SFTP_BY_ID', error);
    dispatch(fetchSftpByIdFailure());
  }
};

export const updateSftpByIdRequest = () => ({
  type: actionTypes.UPDATE_SFTP_BY_ID_REQUEST,
});

export const updateSftpByIdSuccess = () => ({
  type: actionTypes.UPDATE_SFTP_BY_ID_SUCCESS,
});

export const updateSftpByIdFailure = () => ({
  type: actionTypes.UPDATE_SFTP_BY_ID_FAILURE,
});

export const updateSftpById = (configuration) => async (dispatch) => {
  try {
    dispatch(updateSftpByIdRequest());

    await api.updateSftpById(configuration);

    dispatch(updateSftpByIdSuccess());
  } catch (error) {
    console.error('UPDATE_SFTP_BY_ID', error);
    dispatch(updateSftpByIdFailure());
  }
};

export const createSftpRequest = () => ({
  type: actionTypes.CREATE_SFTP_REQUEST,
});

export const createSftpSuccess = () => ({
  type: actionTypes.CREATE_SFTP_SUCCESS,
});

export const createSftpFailure = () => ({
  type: actionTypes.CREATE_SFTP_FAILURE,
});

export const createSftp = (configuration) => async (dispatch) => {
  try {
    dispatch(createSftpRequest());

    await api.createSftp(configuration);

    dispatch(createSftpSuccess());
  } catch (error) {
    console.error('CREATE_SFTP', error);
    dispatch(createSftpFailure());
  }
};



// WEBPACK FOOTER //
// ./src/modules/report-subscriptions/actions/sftp.actions.js